import React from 'react'
import { get } from 'lodash'
import StandAlonePlayers from './standAlonePlayer'
import './style.scss'
import newsLivePlayer from "~/redux/newsLivePlayer/store";
import { updateMiniplayerStatus } from "~/redux/newsLivePlayer/actions";
import connect from "~/tools/connect";
import { getDefaultVideoIndex } from "./helper";
import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import jwtDecode from 'jwt-decode';
import { userLanguageSelector } from "~/tools/localization";
import {getLayout} from '~/redux/websearch/helper';
import axios from 'axios';
import Spinner from "~/components/Spinner";
import { getVideo } from "~/redux/video/helpers";

class MiniStandaloneVideoPlayer extends React.Component{

	state = {
		data: null,
		layout: null,
		currentVideoIndex: null,
		loading: true,
		currentVideo: null,
		mode: "initial",
		shouldPlayAds: false,
	}

	async fetchPageData(){
		const token = await getToken()
		let decodedToken = jwtDecode(token);
		let tokenCountryCode = decodedToken.countryCode;
		let baseUrl = "";
		const { internalName } = window.settings;

		if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
			baseUrl = "https://prod-api-cached-2.viewlift.com"
		} else {
			baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
		}

		const pageData = await axiosWithKey({
			method: "GET",
			url: `${baseUrl}/content/pages?site=${internalName}&path=${'/'}
			&languageCode=${userLanguageSelector()}&includeContent=true&countryCode=${tokenCountryCode}`,
			headers: { Authorization: token }
		})
		const layoutUrl = `${window.settings.layoutUrlBase}${window.settings.siteId}/web/${pageData.data.id}.json`;
		const pageLayout = await axios.get(layoutUrl);
		const homePageLayout = pageLayout.data.moduleList.filter(layout=>layout.type && layout.type.includes('Standalone'));
		const homePageId = homePageLayout.length === 1 ? homePageLayout[0].id : null;
		const homePageData = pageData.data.modules.filter(m=>m.id === homePageId);
		if(homePageId && homePageData.length === 1){
			this.setState({
				data: homePageData[0],
				layout: homePageLayout[0],
				currentVideoIndex: getDefaultVideoIndex({data: homePageData[0]})
			})
		}
	}

	switchMode = (currentVideo, mode) => {
		this.setState({
			loading: false,
			currentVideo: currentVideo,
			mode: mode,
			shouldPlayAds: true,
		});
	}

	fetchPromo = () => {
		const { currentVideoIndex, data } = this.state;
		if (data && data.contentData && data.contentData[currentVideoIndex]) {
			const curPromoId = get(data.contentData[currentVideoIndex], "contentDetails.promos[0].id", null);

			if (curPromoId) {
				// current video has promo
				getVideo(curPromoId, (response) => {
					this.switchMode(response.data.video, "promo")
				}).catch((error) => {
					console.log("fetch promo failed");
					const curVideo = get(data, `contentData[${currentVideoIndex}]`, null);
					this.switchMode(curVideo, "live");
				});
			} else {
				// current video doesn't has a promo
				const curVideo = get(data, `contentData[${currentVideoIndex}]`, null);
				this.switchMode(curVideo, "live");
			}
		}
	};

	videoEndedHandler = () => {
		const {data, mode, currentVideoIndex} = this.state;
		if (mode === "promo" && data) {
			this.setState({
				currentVideo: get(data, `contentData[${currentVideoIndex}]`, null),
				mode: "live",
				shouldPlayAds: false,
			});
		}
	};

	disablePip() {
		localStorage.setItem('enableMiniPlayer', false);
		newsLivePlayer.dispatch(updateMiniplayerStatus({
			enableMiniPlayer: false
		}))
	}
	async componentDidMount(){
		await this.fetchPageData();
		this.fetchPromo();

		let hasMiniPlayerToggle = document.getElementsByClassName('mini-player-toggle').length > 0;

		// if masthead has no mini player toggle, enable it at when component mount as always
		if(!hasMiniPlayerToggle){
			localStorage.setItem('enableMiniPlayer', true);
			newsLivePlayer.dispatch(updateMiniplayerStatus({
				enableMiniPlayer: true
			}))
		}
	}

	renderPlayer = () => {
		const { data, layout, currentVideoIndex, loading, currentVideo, mode, shouldPlayAds } = this.state;
		if(this.state.loading){
			return <div className="miniplayer-spinner-wrapper">
						<Spinner />
					</div>
		}

		return <StandAlonePlayers
			currentVideo={{...currentVideo}}
			isPip={true}
			disablePip={this.disablePip.bind(this)}
			hideAds={get(layout, "settings.hideAds")}
			videoEndedHandler={this.videoEndedHandler.bind(this)}
			shouldPlayAds={shouldPlayAds}
			mutePlayerAtBeginning={true}
			isPromo={mode === 'promo'}
		/>
	}

	render(){
		const { enableMiniPlayer, data, layout} = this.state;
			

		if(data && layout){
			return (
					<div className="news-standalone-videoplayer-container mini-player" style={{marginBottom: '0px'}}>
						{enableMiniPlayer && this.renderPlayer()}
					</div>
				);
		}
		return <div></div>
	}
}

connect(
	MiniStandaloneVideoPlayer,
	state => ({ enableMiniPlayer: state.enableMiniPlayer }),
	newsLivePlayer
);

export default MiniStandaloneVideoPlayer